import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export function launchBugSnag(config, Vue) {
  Bugsnag.start({
    apiKey: config.apiKey,
    plugins: [new BugsnagPluginVue()],
    releaseStage: config.env,
    appVersion: config.version
  })

  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)
}

export function setUserBugSnag(user) {
  if (isBugSnagLaunch()) {
    if (!user) return

    Bugsnag.setUser(user.preferred_username, user.name, user.email)
  }
}

export function triggerBugsnagEvent() {
  if (isBugSnagLaunch()) {
    Bugsnag.notify(new Error('Test error'))
  }
}

function isBugSnagLaunch() {
  return !!Bugsnag._client
}
